import React, { useEffect, useRef } from 'react';
import _ from 'lodash';
import L from 'leaflet';
import { useMap } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import cx from 'classnames';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import ContextMenu from '../ui/contextmenu';
import { setTvWallCameras, setDialogMode, setDialogData, dialogInfo, setDialogInfo } from '../../redux/traffic-live';
var t = i18n.getFixedT(null, 'traffic-live');
var ITSMarkers = /*#__PURE__*/React.memo(function (props) {
  var data = props.data,
      markerTypes = props.markerTypes;

  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      tvWallCameras = _useSelector.trafficLive.tvWallCameras;

  var dispatch = useDispatch();
  var markersLayerGroup = useRef();
  var map = useMap(); // const ref_tvwallCameras

  var clearAllMarkers = function clearAllMarkers() {
    if (!markersLayerGroup.current) return;
    markersLayerGroup.current.clearLayers();
    markersLayerGroup.current = null;
  };

  var openContextMenu = function openContextMenu(e, markerData) {
    if (markerData.dataType !== 'camera') return;
    var menuItems = new Array();
    menuItems.push({
      id: 'contextmenu-tvwall',
      className: 'contextmenu tvwall',
      text: t('lbl-add-tvwall'),
      action: function action() {
        var isExceed = true;

        var newData = _.cloneDeep(tvWallCameras);

        for (var i = 0; i < 4; i++) {
          if (_.isEmpty(newData[i])) {
            newData[i] = markerData;
            isExceed = false;
            break;
          }
        }

        if (isExceed) {
          return dispatch(setDialogInfo({
            mode: 'errorMessage',
            data: {
              errorMessage: t('txt-tvwall-exceed-limit')
            }
          }));
        }

        dispatch(setTvWallCameras(newData));
      }
    }); // menuItems.push({
    //     id: 'contextmenu-live',
    //     className: 'contextmenu live',
    //     text: t('lbl-live'),
    //     action: () => {
    //         console.log(123)
    //     }
    // })
    // menuItems.push({
    //     id: 'contextmenu-info',
    //     className: 'contextmenu info',
    //     text: t('lbl-information'),
    //     action: () => {
    //     }
    // })

    ContextMenu.open({
      pageX: e.originalEvent.clientX,
      pageY: e.originalEvent.clientY
    }, menuItems);
  };

  var openDialog = function openDialog(markerData) {
    dispatch(setDialogInfo({
      mode: markerData.dataType,
      data: markerData
    }));
  };

  var renderMarkerTooltip = function renderMarkerTooltip(markerData) {
    var noData = t('lbl-no-data');

    switch (markerData.dataType) {
      case 'camera':
        return "<div class='camera-name'>".concat(markerData.location, "</div>");

      case 'live-traffic':
        var forwardSpeed = _.isNumber(markerData.forwardSpeed) && Number(markerData.forwardSpeed) > -1 ? t('lbl-speed', {
          speed: _.round(markerData.forwardSpeed, 2)
        }) : noData;
        var forwardVolume = _.isNumber(markerData.forwardVolume) && Number(markerData.forwardVolume) > -1 ? t('lbl-vehicles', {
          vehicles: _.floor(markerData.forwardVolume)
        }) : noData; // let backwardSpeed = _.isNumber(markerData.backwardSpeed) && Number(markerData.backwardSpeed) > -1 ? t('lbl-speed', {speed: _.round(markerData.backwardSpeed, 2)}) : noData

        return "<div class='title'>".concat(t('lbl-live-traffic'), "</div>\n                    <div class='content-row'>\n                        <i class='fas fa-car-side live-traffic-icon'></i>\n                        <span class='live-traffic-span'>").concat(forwardSpeed, "</span>\uFF0C<span class='live-traffic-span'>").concat(forwardVolume, "</span>\n                    </div>");

      case 'terminal-station':
        var pickUpVehicles = Number(markerData.pickUpTrailerLineQty) > -1 ? t('lbl-vehicles', {
          vehicles: _.round(markerData.pickUpTrailerLineQty)
        }) : t('lbl-no-data');
        var returnVehicles = Number(markerData.returnTrailerLineQty) > -1 ? t('lbl-vehicles', {
          vehicles: _.round(markerData.returnTrailerLineQty)
        }) : t('lbl-no-data');
        var pickUpMinutes = Number(markerData.pickUpEstLineDuration) > -1 ? t('lbl-minutes', {
          minutes: _.round(markerData.pickUpEstLineDuration)
        }) : t('lbl-no-data');
        var returnMinutes = Number(markerData.returnEstLineDuration) > -1 ? t('lbl-minutes', {
          minutes: _.round(markerData.returnEstLineDuration)
        }) : t('lbl-no-data');
        if (markerData.id === 'TWKHH_TS03') return "<div class=''>".concat(markerData.name, "</div>");
        return "<div class='title'>".concat(markerData.name, "</div>\n                    <div class='content-row'>\n                        <img src=").concat(contextRoot, "/images/icon/icon-ic-car.png />\n                        <span>").concat(t('lbl-pickUp')).concat(pickUpVehicles, "\uFF0C").concat(t('lbl-return')).concat(returnVehicles, "</span>\n                    </div>\n                    <div class='content-row'>\n                        <img src=").concat(contextRoot, "/images/icon/icon-ic-time.png />\n                        <span>").concat(t('lbl-pickUp')).concat(pickUpMinutes, "\uFF0C").concat(t('lbl-return')).concat(returnMinutes, "</span>\n                    </div>");

      case 'gate-station':
        return "<div class='title'>".concat(markerData.name, "</div>\n                    <div class='content-row'>\n                        <img src=").concat(contextRoot, "/images/icon/icon-ic-time.png />\n                        <span>").concat(Number(markerData.estVisitDuration) > -1 ? t('lbl-minutes', {
          minutes: markerData.estVisitDuration
        }) : t('lbl-no-data'), "</span>\n                    </div>");

      default:
        return null;
    }
  };

  useEffect(function () {
    clearAllMarkers();
    markersLayerGroup.current = new L.layerGroup();
    var markerClusterGroup = new L.MarkerClusterGroup({
      showCoverageOnHover: false,
      spiderfyDistanceMultiplier: 2,
      maxClusterRadius: function maxClusterRadius() {
        return 40;
      },
      iconCreateFunction: function iconCreateFunction(cluster) {
        var list = _.map(cluster.getAllChildMarkers(), function (m) {
          return _.get(m, 'options.icon.options.className');
        });

        return L.divIcon({
          html: "<span>".concat(cluster.getChildCount(), "</span>"),
          className: cx('marker-cluster'),
          iconSize: L.point(30, 30, true)
        });
      }
    });

    var markersData = _.filter(data, function (el) {
      return el.longitude && el.latitude;
    });

    var newMarkers = _.map(markersData, function (el) {
      var markerType = _.find(markerTypes, function (o) {
        return o.dataType === el.dataType;
      });

      var iconUrl = "".concat(contextRoot).concat(markerType.iconUrl);
      var level = Number(el.congestionStatus) === -1 ? 'no-data' : el.congestionStatus ? "level".concat(el.congestionStatus) : ''; // 1, 2, 3

      var markerIcon = L.divIcon({
        className: cx('its-marker', level),
        html: "<img class=\"icon\" src=".concat(iconUrl, " width=\"20\" height=\"20\" />"),
        iconSize: [26, 26],
        iconAnchor: [18, 26]
      });
      var marker = L.marker({
        lon: el.longitude,
        lat: el.latitude
      }, {
        icon: markerIcon
      });
      marker.on('click', function () {
        return openDialog(el);
      });
      marker.on('contextmenu', function (e) {
        return openContextMenu(e, el);
      });
      marker.on('mouseover', function (e) {
        return e.target.openTooltip();
      });
      marker.on('mouseout', function (e) {
        return e.target.closeTooltip();
      });

      if (el.dataType !== 'roads-event') {
        var tooltipIcon = renderMarkerTooltip(el);
        var tooltipOptions = {
          // permanent: true, // always open
          className: "its-tooltip ".concat(el.dataType, "-tooltip"),
          direction: 'bottom',
          offset: [2, 0],
          opacity: 1
        };
        marker.bindTooltip(tooltipIcon, tooltipOptions);
      }

      return marker;
    });

    markerClusterGroup.addLayers(newMarkers);
    markerClusterGroup.addTo(markersLayerGroup.current);
    markersLayerGroup.current.addTo(map);
    return function () {
      clearAllMarkers();
    };
  }, [JSON.stringify(data), JSON.stringify(tvWallCameras)]);
  return null;
});
export default ITSMarkers;